export default state => state.auth.fetching.login;
